module.exports = __webpack_public_path__ + "img/bg.36e1f172.png";